import { loadPlaces } from "./loader";
import type { AutocompleteService, PlacesService } from "./types";

let singletonAutocompleteService: AutocompleteService | null = null;
let singletonPlacesService: PlacesService | null = null;

export const _resetSingletons = () => {
  singletonAutocompleteService = null;
  singletonPlacesService = null;
};

const initializeAutocompleteService = async (): Promise<AutocompleteService> => {
  const { AutocompleteService } = await loadPlaces();
  singletonAutocompleteService = new AutocompleteService();
  return singletonAutocompleteService;
};

export const getAutocompleteService = async () =>
  singletonAutocompleteService
    ? singletonAutocompleteService
    : await initializeAutocompleteService();

export const getAutocompleteSessionToken = async () => {
  const { AutocompleteSessionToken } = await loadPlaces();
  return new AutocompleteSessionToken();
};

const initializePlacesService = async (): Promise<PlacesService> => {
  const { PlacesService } = await loadPlaces();
  // FIXME: this document create sucks, but is required
  singletonPlacesService = new PlacesService(document.createElement("div"));
  return singletonPlacesService;
};

export const getPlacesService = async () =>
  singletonPlacesService
    ? singletonPlacesService
    : await initializePlacesService();
